import React, { useState, useEffect, useCallback, useContext } from 'react';
import Recinto from './Recinto';
import Eventos from './Eventos';
import { AuthContext } from '../contexts/AuthContext';
import { apiFetch } from '../utils/apiFetch';
import { Link, useNavigate } from 'react-router-dom';

interface Client 
{
  id: number;
  name: string;
  login: string;
  password: string;
}

const Recintos: React.FC = () => 
{
  const { token } = useContext(AuthContext);
  const [clients, setClients] = useState<Client[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  const navigate = useNavigate();

  //-----------------------------------------------------------

  const fetchClients = useCallback(async () => 
  {
    setLoading(true);
    try 
    {
      const response = await apiFetch('web/get_clients');

      if (response.ok) 
      {
        const data = await response.json();
        setClients(data);
      } 
      else 
      {
        throw new Error('Error al cargar clientes.');
      }
    } 
    catch (error) 
    {
      const errorMsg = error instanceof Error ? error.message : 'Error desconocido';
      setError(errorMsg);
    } 
    finally 
    {
      setLoading(false);
    }
  }, [token]);

  //-----------------------------------------------------------

  useEffect(() => 
  {
    fetchClients();
  }, [fetchClients]);

  //-----------------------------------------------------------

  const handleCreateClick = () => 
  {
    setSelectedClient({
      id: -1, // Para indicar que es un nuevo cliente
      name: '',
      login: '',
      password: '',
    });
  };

  //-----------------------------------------------------------

  const handleEditClick = (client: Client) => 
  {
    setSelectedClient(client);
  };

  //-----------------------------------------------------------

  const handleFormClose = () => 
  {
    setSelectedClient(null);
    fetchClients();
  };

  //-----------------------------------------------------------

  // const handleEventsClick = (clientId: number) => 
  // {
  //   navigate(`/main/recintos/${clientId}/eventos`);
  // };

  //-----------------------------------------------------------

  const findClientNameById = (id: number) => 
  {
    const client = clients.find(client => client.id === id);
    return client ? client.name : '';
  };

  //-----------------------------------------------------------

  return (
    <div className="eventos-container">
      {selectedClient === null ? (
        <div>
          <div className="cod-toolbar" style={{ justifyContent: 'flex-end' }}>
              <button className="icon-btn icon-btn--create" onClick={handleCreateClick}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M12 5v14M5 12h14"/>
                </svg>
                Crear recinto
              </button>
          </div>
          {loading && <p>Buscando clientes...</p>}
          {error && <p className="error-message">{error}</p>}
          {!loading && !error && clients.length === 0 && (
            <p>No hay clientes para mostrar.</p>
          )}
          {!loading && !error && clients.length > 0 && (
            <div className=" table-scroll">
            <table className="eventos-table">
              <tbody>
                {clients.map(client => (
                  <tr key={client.id}>
                    <td className="evento-name">{client.name}</td>
                    <td className="evento-actions">
                      <div className="icon-btn-group">
                        <button
                          className="icon-btn icon-btn--edit"
                          onClick={() => handleEditClick(client)}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                          Editar
                        </button>
                        <Link
                          to={`/main/recintos/${client.id}/eventos`}
                          className="icon-btn icon-btn--codes"
                          style={{ textDecoration: 'none' }}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>
                          </svg>
                          Eventos
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>
      ) : (
        <div className="form-overlay">
          <Recinto
            client={selectedClient}
            onSave={handleFormClose}
            onCancel={handleFormClose}
            onDelete={(clientId) => {
              setClients(clients.filter(client => client.id !== clientId));
              handleFormClose();
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Recintos;
